import React, {useContext} from "react"
import {injectIntl} from "react-intl";
import Column from "@amzn/meridian/column";
import {getAdtfProtocols} from "../../util/Validations";
import {ADTF_ASSET_TYPE} from "../../util/Constants";
import {AdtfDeviceOverviewContext} from "./context/AdtfDeviceOverviewContext";
import CommonDeviceLogstream from "../../commonui/CommonDeviceLogstream";

const AdtfDeviceLogstream = ({intl}) => {

    const {viewModel, dispatch} = useContext(AdtfDeviceOverviewContext);
    const deviceList = Object.values(viewModel.adtfDeviceInformation);

    const props = {
        protocols: getAdtfProtocols(),
        dispatch,
        deviceList,
        deviceType: ADTF_ASSET_TYPE,
        intl
    }
    return (
        <Column>
            <CommonDeviceLogstream {...props}/>
        </Column>
    );
}

export default injectIntl(AdtfDeviceLogstream)


// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtfdevice/AdtfDeviceLogstream.js